import React from 'react';
import './SectionHeader.css';

interface Props {
  title: string;
  caption?: string;
  action?: React.ReactNode;
}

export function SectionHeader({ title, caption, action }: Props) {
  return (
    <div className="staff-section-header">
      <div className="staff-section-header-text">
        <h2>{title}</h2>
        {caption && <span>{caption}</span>}
      </div>
      {action && <div className="staff-section-header-action">{action}</div>}
    </div>
  );
}
